import { render } from "./PagePilihTimPenilaian.vue?vue&type=template&id=07899ed6"
import script from "./PagePilihTimPenilaian.vue?vue&type=script&lang=js"
export * from "./PagePilihTimPenilaian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__